import { Blockquote, Inset, Text } from "@radix-ui/themes";
import AddBottomSpace from "../../components/AddBottomSpace";
import AddHeadline from "../../components/AddHeadline";
import AddTopSpace from "../../components/AddTopSpace";

export default function Collaborators() {

  return (
    <>
      <AddTopSpace />
      <AddHeadline />
      <div className="container">

        <div className='row'>

          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="6" color>
                    Collaborators
                  </Blockquote>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div className='row'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Inset clip="padding-box" side="top" pb="current">
                    <img
                      src="https://www.shadvala.org/img/interstices-anand.jpg"
                      alt="Anand Mishra"
                      style={{
                        display: 'block',
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'var(--gray-5)',
                      }}
                    />
                    <Text as="p" mb="5" size="2">
                      Anand Mishra
                    </Text>
                  </Inset>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="6" mb="5" color>
                    Anand Mishra
                  </Blockquote>
                  <Text as="p" mb="5" size="4">
                  Anand Mishra stems from the traditional scholarly milieu of Benares, which was the main pillar of his education. 
                  He studied Mathematics at the Indian Institute of Technology, Kanpur.
                  He currently works at the University of Heidelberg, where he did his PhD in Classical Indology and joined the Department of South Asian Studies fifteen years ago. 
                  He combines knowledge of exact science (mathematics), technology (computer science) and humanities (South Asian studies). 
                  His main research fields are knowledge transmission, Sanskrit grammar, and ritual studies. 
                  He also works on a non-Western-oriented intellectual and pedagogical approach to Indian sacred literature. 
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>


        <div className='row'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Inset clip="padding-box" side="top" pb="current">
                    <img
                      src="https://www.shadvala.org/img/interstices-sarah.jpg"
                      alt="Sarah Eichner"
                      style={{
                        display: 'block',
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'var(--gray-5)',
                      }}
                    />
                    <Text as="p" mb="5" size="2">
                      Sarah Eichner
                    </Text>
                  </Inset>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="6" mb="5" color>
                    Sarah Eichner
                  </Blockquote>
                  <Text as="p" mb="5" size="4">
                    Sarah Eichner is a philosopher and writer whose work focuses on Western and Chinese traditions. 
                    Her PhD project was based on a re-reading of the notion of Earth (Kun) in the context of the ancient Book of Changes (Yijing), out of which she developed a phenomenology of the earth with ecosophical implications. 
                    Her present field of interest is centered on non-dual, animistic, and shamanic forms of relations as well as on an enhanced interaction between humans and non-humans on perceptive, imaginative, and cognitive levels. 
                    She worked as former Assistant of the domain Research and Intellectual Dialogue at the Alain Daniélou Foundation and helped shaping an open dialogue between transcultural philosophy and depth psychology. 
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>







        <div className='row'>
          
          <div className='col-lg-4'>
            <div className="container py-3">
              <div className='row pb-1'>
                <div className='col'>
                  <Inset clip="padding-box" side="top" pb="current">
                    <img
                      src="https://www.shadvala.org/img/interstices-valerio.JPG"
                      alt="Valerio Lucia"
                      style={{
                        display: 'block',
                        objectFit: 'cover',
                        width: '80%',
                        height: '80%',
                        backgroundColor: 'var(--gray-5)',
                      }}
                    />
                    <Text as="p" mb="5" size="2">
                      Valerio Lucia (Photo by Manuela di Flora)
                    </Text>
                  </Inset>
                </div>
              </div>
            </div>
          </div>
          
          <div className='col-lg-8'>
            <div className="container py-3">
              <div className='row pb-3'>
                <div className='col'>
                  <Blockquote size="6" mb="5" color>
                    Valerio Lucia
                  </Blockquote>
                  <Text as="p" mb="5" size="4">
                    Valerio Lucia is philologist and musician. He studied at the Universities of La Sapienza (Italy) and Freiburg im Breisgau (Germany), after which he taught Italian at the Humboldt University in Berlin, and he is currently working in Italy. He is deeply involved in the Afro-Brazilian traditions of Candomblé and Umbanda, where he became “Ogã” (official percussionist playing drums for the Orixás), and he is also researching the surviving Pagan layers of rural Italy. 
                  </Text>
                </div>
              </div>
            </div>
          </div>

        </div>











      </div>
      
      <AddBottomSpace />
    </>
  )
}
